





import mixins from 'vue-typed-mixins';
import Vue from 'vue';
import { User } from '@/Stores/UserStore';
import UserMixin from '@/Shared/UserMixin';

export default mixins(UserMixin).extend({
    async mounted() {
        await this.loadUser();

        if (this.isInternal && this.user.defaultLocation) {
            this.$router.push({ name: 'locationRoot', params: { location: this.user.defaultLocation } });
        }
        else {
            this.$router.push({ name: 'vatsLogin' });
        }
    }
});
